import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})

export class QBRService {
    private baseURL: string;
    constructor(private http: HttpClient,
        private authService: AuthService
    ) {
        this.baseURL = environment.apiBaseUrl;
    }

    public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    GetWRQuickBoothRentalData(MarketId: any): Observable<any[]> {
        
        return this.http.get<any[]>(
            `${this.baseURL}/QuickBoothRental/GetWRQuickBoothRentalData?marketId=` + MarketId,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any[];
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    SaveQuickBoothRentalData(marketId,qbrmodel): Observable<any> {
        const url = `${this.baseURL}/QuickBoothRental/SaveQuickBoothRentalData/${marketId}`;
        return this.http.post<any>(url, qbrmodel, this.options)
            .pipe(
                map(res => {
                    const response = res as any;
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}